import { keyframes } from "@emotion/css";
import styled from "@emotion/styled";
import {
  StyledCardBrand,
  StyledCardPrices,
  StyledCardRegularPrice,
} from "src/molecules/ProductCard/ProductCard.styled";

const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.tone.white};
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  max-height: 100dvh;
  overflow-x: hidden;
  overflow-y: auto;
  padding: ${({ theme }) => theme.space.space16};
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints[1]}) {
    animation: ${slideUp} 0.3s ease;
    border-radius: 16px 16px 0 0;
    box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.08);
    padding-bottom: ${({ theme }) => theme.space.space0};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    max-height: calc(100vh - ${({ theme }) => theme.space.space64});
    max-height: calc(100dvh - ${({ theme }) => theme.space.space64});
    padding: ${({ theme }) => theme.space.space32};
    width: 560px;
  }
`;

const Header = styled.div`
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.space.space8};
  justify-content: space-between;
`;

const Content = styled.div`
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.space.space16};
  padding-top: ${({ theme }) => theme.space.space16};
`;

const Image = styled.img`
  flex-shrink: 0;
  height: 120px;
  object-fit: cover;
  width: 80px;
`;

const DescriptionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.space4};
  min-width: 0;
`;

const BrandName = styled.span`
  color: ${({ theme }) => theme.colors.tone.black};
  font-size: ${({ theme }) => theme.fontSizes.fontSize16};
  font-weight: 600;
  line-height: 24px;
`;

const ProductName = styled.span`
  color: ${({ theme }) => theme.colors.tone.black};
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  font-weight: 400;
  line-height: 20px;
`;

const SizeContent = styled.div`
  color: ${({ theme }) => theme.colors.tone.black};
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  font-weight: 400;
  line-height: 20px;

  & > span:first-of-type {
    margin-right: ${({ theme }) => theme.space.space4};
  }
`;

const PriceContent = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  font-weight: 400;
  gap: ${({ theme }) => theme.space.space8};
  line-height: 20px;

  > span:first-of-type {
    color: ${({ theme }) => theme.colors.tone.black};
    font-weight: 600;
  }

  .promo-code {
    align-items: center;
    color: ${({ theme }) => theme.colors.semantic.red};
    display: inline-flex;
    font-size: ${({ theme }) => theme.fontSizes.fontSize14};
    font-weight: ${({ theme }) => theme.fontWeights.body};

    svg {
      height: ${({ theme }) => theme.fontSizes.fontSize14};
      width: ${({ theme }) => theme.fontSizes.fontSize14};
    }
  }
`;

const SuggestionsWrapper = styled.div`
  padding-top: ${({ theme }) => theme.space.space16};
`;

const SuggestionsTitle = styled.h3`
  color: ${({ theme }) => theme.colors.tone.black};
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  font-weight: 600;
  line-height: 20px;
  margin: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    font-size: ${({ theme }) => theme.fontSizes.fontSize16};
    line-height: 24px;
  }
`;

const SuggestionsCarousel = styled.div`
  padding-top: ${({ theme }) => theme.space.space4};

  ${StyledCardBrand} {
    font-size: ${({ theme }) => theme.fontSizes.fontSize14};
    line-height: 20px;
    margin-top: ${({ theme }) => theme.space.space8};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  ${StyledCardPrices} {
    font-size: ${({ theme }) => theme.fontSizes.fontSize14};
    line-height: 20px;
    padding-bottom: ${({ theme }) => theme.space.space8};
  }

  ${StyledCardRegularPrice} {
    font-size: ${({ theme }) => theme.fontSizes.fontSize14};
    line-height: 20px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    padding-top: ${({ theme }) => theme.space.space8};
  }
`;

const Footer = styled.div`
  padding-top: ${({ theme }) => theme.space.space16};

  @media (max-width: ${({ theme }) => theme.breakpoints[1]}) {
    background-color: ${({ theme }) => theme.colors.tone.white};
    bottom: 0;
    padding-bottom: ${({ theme }) => theme.space.space16};
    position: sticky;
  }
`;

export {
  Wrapper,
  Header,
  Content,
  Image,
  DescriptionContent,
  BrandName,
  ProductName,
  SizeContent,
  PriceContent,
  SuggestionsWrapper,
  SuggestionsTitle,
  SuggestionsCarousel,
  Footer,
};
